{
  "dismiss": "Descartar"
}